import React, { SyntheticEvent } from "react"
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import VerticalTable, { Row } from "@components/VerticalTable"
import { useLocalStorage } from "usehooks-ts"
import Grid from "@mui/material/Grid"

type NodeRowsAccordionProps = {
  nodeRows: Row[]
}

export function NodeRowsAccordion({ nodeRows }: NodeRowsAccordionProps) {
  const [expandedNodeProperties, setExpandedNodeProperties] = useLocalStorage(
    `nodeNodePropertiesAccordionExpanded`,
    true,
  )

  return (
    <Grid item sx={{ width: expandedNodeProperties ? "auto" : "100%" }}>
      <Accordion
        expanded={expandedNodeProperties}
        onChange={(event: SyntheticEvent, isExpanded: boolean) => {
          setExpandedNodeProperties(isExpanded)
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ fontWeight: 700 }}>Node Properties:</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ p: 0 }}>
          <VerticalTable headers={["Property", "Value"]} rows={nodeRows} />
        </AccordionDetails>
      </Accordion>
    </Grid>
  )
}
